import React from 'react';

const PILOT_STEPS = [
    {
        num: '01',
        title: 'Заявка и сценарий',
        text: 'Согласуем продукт, проекты и ожидаемый результат пилота.',
    },
    {
        num: '02',
        title: 'Подключение в контуре',
        text: 'MarginLayer, DevOpsFort или bc — к вашему трекеру, реестру или IDE.',
    },
    {
        num: '03',
        title: 'Первые метрики',
        text: 'Маржа, CVE gate или trial usage — и решение о масштабировании.',
    },
];

const HeroVisual = () => (
    <div className="hero__visual" aria-hidden="true">
        <div className="hero-panel">
            <header className="hero-panel__head">
                <span className="hero-panel__kicker">Пилот</span>
                <span className="hero-panel__meta">Внедрение продукта</span>
            </header>
            <ol className="hero-panel__steps">
                {PILOT_STEPS.map((step) => (
                    <li key={step.num} className="hero-panel__step">
                        <span className="hero-panel__num">{step.num}</span>
                        <div>
                            <p className="hero-panel__step-title">{step.title}</p>
                            <p className="hero-panel__step-text">{step.text}</p>
                        </div>
                    </li>
                ))}
            </ol>
            <footer className="hero-panel__facts">
                <span><strong>3</strong> продукта</span>
                <span><strong>B2B</strong></span>
                <span><strong>RU</strong> · Москва</span>
            </footer>
        </div>
    </div>
);

export default HeroVisual;
